import { AuthService } from '@Services/auth.service';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (_route, _state) => {
  const AUTH_SERVICE = inject(AuthService);
  const ROUTER = inject(Router);

  if (AUTH_SERVICE.isAuthenticated()) {
    return true;
  } else {
    return ROUTER.createUrlTree(['/login-required']);
  }
};
